import { Component, Input } from '@angular/core';
import { LocDisclosureInfo } from '../../apr-calculator.model';

@Component({
    selector: 'ifa-apr-disclosure-ca-lcf',
    templateUrl: './apr-disclosure-ca-lcf.component.html',
    styleUrls: ['../../apr-disclosure.component.scss', './apr-disclosure-ca-lcf.component.scss'],
    standalone: false
})
export class AprDisclosureCaLcfComponent {

    @Input() data: LocDisclosureInfo = new LocDisclosureInfo('', 0, 0, null, null, 0, 0, 0, 0);
}